import AsyncStorage from '@react-native-async-storage/async-storage';
import { connect } from 'react-redux';
import Onboarding from './Onboarding';
import { resetToWelcomeScreen } from '../../modules/Navigation/actions';

import type { DispatchProps } from './Onboarding';
import WizzeeLog from '../../lib/wizzeeLog';

const mapDispatchToProps = (dispatch): DispatchProps => ({
  resetToWelcomeScreen: () => {
    return AsyncStorage.setItem('HAS_ALREADY_OPENED_APP', 'true')
      .catch(e => WizzeeLog.warn('Error setting HAS_ALREADY_OPENED_APP', e))
      .finally(() => resetToWelcomeScreen());
  },
});

export default connect(null, mapDispatchToProps)(Onboarding);
